/* Counter Store Locator widget.
 * Requires: maplibre-gl (JS+CSS), counter-locator.css, data/stores.json, logos/.
 * Usage: CounterLocator.init({ el: '#counter-locator', dataUrl: 'data/stores.json', logoBase: 'logos/' })
 */
(function () {
  "use strict";

  var PIN_SVG = '<svg class="pin" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2H168.3zM192 256C227.3 256 256 227.3 256 192C256 156.7 227.3 128 192 128C156.7 128 128 156.7 128 192C128 227.3 156.7 256 192 256z"/></svg>';
  var SEARCH_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>';
  var MAP_STYLE = "https://tiles.openfreemap.org/styles/bright";
  var PAGE_SIZE = 25;
  var MAX_RESULTS = 125;

  var S = {
    data: null, map: null, markers: {}, popup: null,
    center: null, results: [], page: 0, selected: null,
    activeFilters: new Set(), tab: "instore", expandedStore: null,
    root: null, opts: null, acTimer: null, acItems: [], acIndex: -1,
    analyticsFails: 0, userChoseLocation: false
  };
  // Fallback view center when IP geolocation is blocked: US population centroid,
  // so the default list leads with mid-country stores instead of raw file order.
  var DEFAULT_CENTER = { lat: 39.5, lng: -96.5, isDefault: true };

  /* ---------------- analytics ---------------- */
  var WIDGET_V = "2";
  function stableId(store, key) {
    try {
      var v = store.getItem(key);
      if (!v) { v = Math.random().toString(36).slice(2) + Date.now().toString(36); store.setItem(key, v); }
      return v;
    } catch (e) { return Math.random().toString(36).slice(2) + Date.now().toString(36); }
  }
  var SESSION = stableId(window.sessionStorage, "cw_sid");   // survives refresh
  var VISITOR = stableId(window.localStorage, "cw_vid");     // survives return visits
  var INTERNAL = false;
  try {
    if (/[?&]cl_debug=1/.test(location.search)) localStorage.setItem("cw_internal", "1");
    if (/[?&]cl_debug=0/.test(location.search)) localStorage.removeItem("cw_internal");
    INTERNAL = localStorage.getItem("cw_internal") === "1";
  } catch (e) { /* storage blocked */ }
  function nearestMi() {
    var f = S.results && S.results[0];
    return f && f.d != null ? Math.round(f.d * 10) / 10 : null;
  }
  function track(event, props) {
    props = props || {};
    var row = {
      session_id: SESSION,
      visitor_id: VISITOR,
      v: WIDGET_V,
      event: event,
      tab: S.tab,
      is_mobile: window.matchMedia("(max-width: 767px)").matches,
      referrer: (document.referrer || "").slice(0, 200),
      href: (location.href || "").slice(0, 300),
      ua: (navigator.userAgent || "").slice(0, 160)
    };
    if (INTERNAL) row.internal = true;
    Object.keys(props).forEach(function (k) { if (props[k] != null) row[k] = props[k]; });
    // Sink 1: GA4 / GTM if the site runs it
    try {
      if (window.dataLayer) window.dataLayer.push({ event: "locator_" + event, locator: props });
      if (typeof window.gtag === "function") window.gtag("event", "locator_" + event, props);
    } catch (e) { /* analytics must never break the widget */ }
    // Sink 2: first-party capture (Supabase REST, insert-only anon policy)
    var a = S.opts.analytics;
    if (a && a.url && a.anonKey && S.analyticsFails < 3) {
      try {
        var hdrs = { "Content-Type": "application/json", "apikey": a.anonKey, "Prefer": "return=minimal" };
        if (a.anonKey.indexOf("eyJ") === 0) hdrs["Authorization"] = "Bearer " + a.anonKey; // legacy JWT keys only
        fetch(a.url.replace(/\/$/, "") + "/rest/v1/locator_event", {
          method: "POST", keepalive: true, headers: hdrs,
          body: JSON.stringify(row)
        }).catch(function () { S.analyticsFails++; });
      } catch (e) { /* ignore */ }
    }
  }
  function activeFilterNames() {
    return Array.from(S.activeFilters).map(function (pi) {
      var p = S.data.products[pi]; return p.name + " " + p.size;
    }).join("; ").slice(0, 300) || null;
  }

  /* ---------------- utils ---------------- */
  function h(html) { var t = document.createElement("template"); t.innerHTML = html.trim(); return t.content.firstChild; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function haversine(a, b) {
    var R = 3958.8, dLat = (b.lat - a.lat) * Math.PI / 180, dLng = (b.lng - a.lng) * Math.PI / 180;
    var s = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a.lat * Math.PI / 180) * Math.cos(b.lat * Math.PI / 180) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.asin(Math.sqrt(s));
  }
  function logoUrl(banner, pin) {
    var slug = S.data.logos[banner];
    if (!slug) return null;
    // Two artwork sets: "list" (authentic brand proportions, breathing room)
    // and "pin" (high-fill for map visibility). Exact per-file URLs preferred.
    var urls = pin ? (S.opts.logoUrlsPin || S.opts.logoUrls) : S.opts.logoUrls;
    if (urls && urls[slug]) return urls[slug];
    var base = pin ? (S.opts.logoPinBase || S.opts.logoBase) : S.opts.logoBase;
    return base.indexOf("{slug}") >= 0 ? base.replace("{slug}", slug) : base + slug + ".png";
  }
  var STORE_GLYPH = '<svg viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg" style="position:absolute;inset:22%;width:56%;height:56%;fill:#bbb"><path d="M547.6 103.8L490.3 13.1C485.2 5 476.1 0 466.4 0H109.6C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4zM499.7 254.9l-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3V384H128V250.6c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V384v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V384 252.6c-4 1-8 1.8-12.3 2.3z"/></svg>';
  function logoEl(banner, cls, pin) {
    var u = logoUrl(banner, pin);
    return '<span class="cw-logo ' + (cls || "") + '"><span class="cw-logo-circle">' +
      (u ? '<img alt="" loading="lazy" src="' + esc(u) + '">' : STORE_GLYPH) + "</span></span>";
  }
  function storeAddr(st) { return st.a + ", " + st.c + ", " + st.s + " " + st.z; }
  function mapsUrl(st) { return "https://www.google.com/maps/dir/?api=1&destination=" + encodeURIComponent((st.r === "Walmart" ? "Walmart, " : "") + storeAddr(st)); }
  function prodUrl(st, pi) { var m = S.data.urls[st.r]; return m ? m[String(pi)] : null; }

  /* ---------------- geocoding ---------------- */
  var zipTable = null;   // zips that contain a store (instant, from stores.json)
  var fullZips = null;   // every US zip (lazy-loaded on first digit typed)
  var fullZipsLoading = false;
  function buildZipTable() {
    zipTable = {};
    S.data.stores.forEach(function (st) {
      if (st.z && !zipTable[st.z]) zipTable[st.z] = { lat: st.lat, lng: st.lng, city: st.c, state: st.s };
    });
  }
  function loadFullZips(onReady) {
    if (fullZips || fullZipsLoading || !S.opts.zipsUrl) return;
    fullZipsLoading = true;
    fetch(S.opts.zipsUrl).then(function (r) { return r.json(); }).then(function (d) {
      fullZips = d;
      if (onReady) onReady();
    }).catch(function () { fullZipsLoading = false; /* store zips still work */ });
  }
  function zipLookup(z) {
    if (zipTable[z]) return zipTable[z];
    if (fullZips && fullZips[z]) {
      var v = fullZips[z];
      return { lat: v[0], lng: v[1], city: v[2], state: v[3] };
    }
    return null;
  }
  function zipSuggestions(q) {
    var src = fullZips || zipTable;
    var zips = [];
    for (var z in src) { if (z.indexOf(q) === 0) zips.push(z); }
    zips.sort();
    return zips.slice(0, 5).map(function (z) {
      var t = zipLookup(z);
      return { label: z + " (" + t.city + ", " + t.state + ")", pt: { lat: t.lat, lng: t.lng } };
    });
  }
  function geocode(q) {
    q = q.trim();
    var mzip = q.match(/^(\d{5})(-\d{4})?$/);
    if (mzip) {
      var zt = zipLookup(mzip[1]);
      if (zt) return Promise.resolve({ pt: { lat: zt.lat, lng: zt.lng }, label: mzip[1] + (zt.city ? " (" + zt.city + ", " + zt.state + ")" : "") });
    }
    var url = "https://photon.komoot.io/api/?limit=5&lang=en&q=" + encodeURIComponent(q + (mzip ? " united states" : ""));
    return fetch(url).then(function (r) { return r.json(); }).then(function (d) {
      var f = (d.features || []).filter(function (x) { return x.properties.countrycode === "US"; })[0] || (d.features || [])[0];
      if (!f) throw new Error("no result");
      return { pt: { lat: f.geometry.coordinates[1], lng: f.geometry.coordinates[0] }, label: fmtPhoton(f) };
    }).catch(function () {
      var url2 = "https://nominatim.openstreetmap.org/search?countrycodes=us&format=json&limit=1&q=" + encodeURIComponent(q);
      return fetch(url2).then(function (r) { return r.json(); }).then(function (d) {
        if (!d[0]) throw new Error("no result");
        return { pt: { lat: +d[0].lat, lng: +d[0].lon }, label: d[0].display_name.split(",").slice(0, 2).join(",") };
      });
    });
  }
  function fmtPhoton(f) {
    var p = f.properties;
    return [p.name || p.city, p.state, p.postcode].filter(Boolean).join(", ");
  }
  function autocomplete(q, cb) {
    fetch("https://photon.komoot.io/api/?limit=5&lang=en&bbox=-125,24,-66,50&q=" + encodeURIComponent(q))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var seen = {};
        var items = (d.features || []).filter(function (f) {
          var t = f.properties.type;
          if (["house", "street"].indexOf(t) >= 0) return false;
          var label = fmtPhoton(f);
          if (seen[label]) return false; seen[label] = 1; return true;
        }).slice(0, 5).map(function (f) {
          return { label: fmtPhoton(f), pt: { lat: f.geometry.coordinates[1], lng: f.geometry.coordinates[0] } };
        });
        cb(items);
      }).catch(function () { cb([]); });
  }

  /* ---------------- results ---------------- */
  function computeResults() {
    var c = S.center;
    var list = S.data.stores.filter(function (st) {
      if (S.activeFilters.size === 0) return true;
      return st.p.some(function (pi) { return S.activeFilters.has(pi); });
    });
    if (c) {
      list.forEach(function (st) { st.d = c.isDefault ? null : haversine(c, st); });
      var sc = c.isDefault ? function (st) { return haversine(c, st); } : function (st) { return st.d; };
      list.sort(function (a, b) { return sc(a) - sc(b); });
    }
    S.matchCount = list.length;
    S.results = list.slice(0, MAX_RESULTS);
    S.page = 0; S.selected = null; S.expandedStore = null;
  }

  /* ---------------- render: store list ---------------- */
  function renderList() {
    var wrap = S.root.querySelector(".cw-list");
    wrap.innerHTML = "";
    var pageItems = S.results.slice(S.page * PAGE_SIZE, (S.page + 1) * PAGE_SIZE);
    if (!pageItems.length) {
      wrap.appendChild(h('<div class="cw-empty">No stores found near your search. Try another city or zip, or clear the product filters.</div>'));
    }
    var ul = h('<ul aria-label="Store results"></ul>');
    pageItems.forEach(function (st) {
      var count = filteredCount(st);
      var li = h('<li class="cw-store" tabindex="0" id="cw_store_' + st.id + '">' +
        '<div class="cw-store-name">' + logoEl(st.r) + "<span>" + esc(st.r) + "</span></div>" +
        '<a class="cw-addr" href="' + esc(mapsUrl(st)) + '" target="_blank" rel="noopener">' + esc(storeAddr(st)) + "</a>" +
        (st.d != null ? '<div class="cw-dist">' + fmtDist(st.d) + "</div>" : "") +
        '<button class="cw-found" aria-expanded="false">' + foundLabel(count) + "</button>" +
        "</li>");
      li.addEventListener("click", function (e) { if (e.target.closest("a,button")) return; selectStore(st, "list"); });
      li.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); selectStore(st, "list"); } });
      li.querySelector(".cw-found").addEventListener("click", function (e) { e.stopPropagation(); toggleStoreProducts(st, li); });
      li.querySelector(".cw-addr").addEventListener("click", function (e) {
        e.stopPropagation();
        track("directions", { store_id: st.id, retailer: st.r, url: mapsUrl(st) });
      });
      ul.appendChild(li);
    });
    wrap.appendChild(ul);
    renderPager();
    updateFilterBtn();
    renderMarkers(pageItems);
  }
  function fmtDist(d) { return (d < 10 ? Math.round(d * 10) / 10 : Math.round(d)) + " mi"; }
  function foundLabel(count) {
    return count + " product" + (count === 1 ? "" : "s") + " found";
  }
  function showSearchError(msg) {
    var el = S.root && S.root.querySelector(".cw-search-error");
    if (!el) return;
    if (msg) { el.textContent = msg; el.hidden = false; }
    else { el.textContent = ""; el.hidden = true; }
  }
  function filteredCount(st) {
    if (S.activeFilters.size === 0) return st.p.length;
    return st.p.filter(function (pi) { return S.activeFilters.has(pi); }).length;
  }
  function renderPager() {
    var total = Math.max(1, Math.ceil(S.results.length / PAGE_SIZE));
    var el = S.root.querySelector(".cw-pager");
    el.querySelector(".prev").disabled = S.page <= 0;
    el.querySelector(".next").disabled = S.page >= total - 1;
    el.querySelector(".cw-pager-info").textContent = "Page " + (S.page + 1) + " of " + total;
    el.style.display = S.results.length > PAGE_SIZE ? "" : "none";
  }
  function toggleStoreProducts(st, li) {
    var open = li.querySelector(".cw-store-products");
    var fbtn = li.querySelector(".cw-found");
    if (open) { open.remove(); S.expandedStore = null; if (fbtn) fbtn.setAttribute("aria-expanded", "false"); return; }
    S.root.querySelectorAll(".cw-store-products").forEach(function (n) { n.remove(); });
    S.root.querySelectorAll(".cw-found[aria-expanded=true]").forEach(function (n) { n.setAttribute("aria-expanded", "false"); });
    if (fbtn) fbtn.setAttribute("aria-expanded", "true");
    S.expandedStore = st.id;
    var pis = S.activeFilters.size ? st.p.filter(function (pi) { return S.activeFilters.has(pi); }) : st.p;
    var ul = h('<ul class="cw-store-products" aria-label="Products at this store"></ul>');
    pis.forEach(function (pi) {
      var p = S.data.products[pi];
      var u = prodUrl(st, pi);
      var row = h("<li>" +
        '<img alt="" loading="lazy" src="' + esc(p.img) + '">' +
        '<span class="pn">' + esc(p.name) + "<small>" + esc(p.size) + "</small></span>" +
        (u ? '<a class="cw-sp-btn" href="' + esc(u) + '" target="_blank" rel="noopener">Shop Now<span class="sr-only"> ' + esc(p.name) + " " + esc(p.size) + " at " + esc(st.r) + "</span></a>" : "") +
        "</li>");
      var a = row.querySelector(".cw-sp-btn");
      if (a) a.addEventListener("click", function () {
        track("shop_now", { store_id: st.id, retailer: st.r, product: p.name + " " + p.size, url: u });
      });
      ul.appendChild(row);
    });
    li.appendChild(ul);
    track("products_expand", { store_id: st.id, retailer: st.r });
  }

  /* ---------------- map ---------------- */
  function makeMarker(st) {
    var el = h('<div class="cw-marker" data-id="' + st.id + '" aria-label="' + esc(st.r) + ' map marker" role="button"><div class="cw-marker-inner">' + PIN_SVG + logoEl(st.r, "", true) + "</div></div>");
    el.addEventListener("click", function (e) { e.stopPropagation(); selectStore(st, "pin"); });
    return new maplibregl.Marker({ element: el, anchor: "bottom" }).setLngLat([st.lng, st.lat]).addTo(S.map);
  }
  function matchesFilters(st) {
    return S.activeFilters.size === 0 || st.p.some(function (pi) { return S.activeFilters.has(pi); });
  }
  // Markers are viewport-driven and clustered at wide zooms:
  // individual branded pins for as long as possible, rolled-up count bubbles
  // only when the view is too wide for single stores to make sense.
  // Tuning knobs (radius/maxZoom/minPoints) are exposed via opts.cluster.
  // Values chosen by the 2026-07-29 parameter-sweep swarm (18 combos, 5 scenarios):
  // clusters only at zoom <= 7 (nation/state views), individual branded pins from
  // metro zoom inward, national frame ~18 markers with all map labels readable.
  var CLUSTER = { radius: 80, maxZoom: 7, minPoints: 3 };
  var storesById = null;
  function storesFC() {
    var feats = [];
    S.data.stores.forEach(function (st) {
      if (!matchesFilters(st)) return;
      feats.push({ type: "Feature", properties: { id: String(st.id) },
        geometry: { type: "Point", coordinates: [st.lng, st.lat] } });
    });
    return { type: "FeatureCollection", features: feats };
  }
  function ensureClusterSource() {
    if (!S.map || !S.data || S.clusterReady) return;
    if (!S.map.isStyleLoaded()) { S.map.once("load", ensureClusterSource); return; }
    storesById = {};
    S.data.stores.forEach(function (st) { storesById[String(st.id)] = st; });
    S.map.addSource("stores", {
      type: "geojson", data: storesFC(),
      cluster: true, clusterRadius: CLUSTER.radius,
      clusterMaxZoom: CLUSTER.maxZoom, clusterMinPoints: CLUSTER.minPoints
    });
    // invisible-but-queryable layer: queryRenderedFeatures on it returns exactly
    // the clusters/points for the CURRENT zoom's tiles (querySourceFeatures
    // leaks stale features from previously loaded zoom levels)
    S.map.addLayer({ id: "stores-ghost", type: "circle", source: "stores",
      paint: { "circle-radius": 8, "circle-opacity": 0 } });
    S.clusterReady = true;
    S.map.on("sourcedata", function (e) {
      if (e.sourceId === "stores" && e.isSourceLoaded) syncViewportMarkers();
    });
    syncViewportMarkers();
  }
  function clusterSize(count) {
    return count >= 200 ? 60 : count >= 50 ? 52 : count >= 10 ? 44 : 36;
  }
  function makeClusterMarker(f) {
    var count = f.properties.point_count;
    var px = clusterSize(count);
    var el = h('<div class="cw-cluster" role="button" aria-label="' + count + ' stores in this area" style="width:' + px + "px;height:" + px + 'px"><span>' + f.properties.point_count_abbreviated + "</span></div>");
    var cid = f.properties.cluster_id;
    var coords = f.geometry.coordinates;
    el.addEventListener("click", function (e) {
      e.stopPropagation();
      var fallback = function () { S.map.easeTo({ center: coords, zoom: S.map.getZoom() + 2, duration: 500 }); };
      try {
        S.map.getSource("stores").getClusterExpansionZoom(cid).then(function (z) {
          S.map.easeTo({ center: coords, zoom: Math.min(z + 0.3, 14), duration: 500 });
        }).catch(fallback);
      } catch (err) { fallback(); }
      track("cluster_zoom", { result_count: count, lat: coords[1], lng: coords[0] });
    });
    return new maplibregl.Marker({ element: el, anchor: "center" }).setLngLat(coords).addTo(S.map);
  }
  var MAX_MARKERS = 300;
  function syncViewportMarkers() {
    if (!S.map || !S.data) return;
    if (!S.clusterReady) { ensureClusterSource(); return; }
    var feats;
    try { feats = S.map.queryRenderedFeatures({ layers: ["stores-ghost"] }); }
    catch (e) { feats = []; }
    var want = {}, seen = {}, shown = 0;
    for (var i = 0; i < feats.length && shown < MAX_MARKERS; i++) {
      var f = feats[i];
      var key = f.properties.cluster ? "c" + f.properties.cluster_id : "s" + f.properties.id;
      if (seen[key]) continue;
      seen[key] = true;
      want[key] = f;
      shown++;
    }
    Object.keys(S.markers).forEach(function (k) {
      if (!want[k]) { S.markers[k].remove(); delete S.markers[k]; }
    });
    Object.keys(want).forEach(function (k) {
      if (S.markers[k]) return;
      var f = want[k];
      if (f.properties.cluster) {
        S.markers[k] = makeClusterMarker(f);
      } else {
        var st = storesById[f.properties.id];
        if (st) S.markers[k] = makeMarker(st);
      }
    });
    if (S.selected != null && S.markers["s" + S.selected]) {
      S.markers["s" + S.selected].getElement().classList.add("selected");
    }
  }
  function refreshClusterData() {
    if (S.clusterReady) S.map.getSource("stores").setData(storesFC());
  }
  function renderMarkers(pageItems) {
    S.lastPage = pageItems;
    if (!S.map) return;
    if (S.popup) { S.popup.remove(); S.popup = null; }
    fitToResults(pageItems);
    syncViewportMarkers();
  }
  function isMobile() { return window.matchMedia("(max-width: 767px)").matches; }
  function fitPadding() {
    return isMobile()
      ? { top: 130, bottom: 60, left: 40, right: 40 }
      : { top: 80, bottom: 80, left: 380, right: 120 };
  }
  function fitToResults(pageItems, bounds) {
    if (!S.map || !pageItems || !pageItems.length) return;
    if (S.center) {
      var b2 = new maplibregl.LngLatBounds();
      b2.extend([S.center.lng, S.center.lat]);
      pageItems.slice(0, 6).forEach(function (st) { b2.extend([st.lng, st.lat]); });
      S.map.fitBounds(b2, { padding: fitPadding(), maxZoom: 13, duration: 700 });
    } else {
      if (!bounds) {
        bounds = new maplibregl.LngLatBounds();
        pageItems.forEach(function (st) { bounds.extend([st.lng, st.lat]); });
      }
      S.map.fitBounds(bounds, { padding: fitPadding(), maxZoom: 11, duration: 0 });
    }
  }
  function selectStore(st, source) {
    var fromList = source === "list";
    S.selected = st.id;
    track("store_select", { store_id: st.id, retailer: st.r, lat: st.lat, lng: st.lng, via: source });
    S.root.querySelectorAll(".cw-store").forEach(function (n) { n.classList.toggle("selected", n.id === "cw_store_" + st.id); });
    Object.keys(S.markers).forEach(function (k) { S.markers[k].getElement().classList.toggle("selected", k === "s" + st.id); });
    if (!fromList) {
      var li = S.root.querySelector("#cw_store_" + CSS.escape(String(st.id)));
      if (li) li.scrollIntoView({ block: "nearest", behavior: "smooth" });
    }
    if (!S.map) return;
    S.map.easeTo({ center: [st.lng, st.lat], zoom: Math.max(S.map.getZoom(), 12), duration: 500, padding: { left: isMobile() ? 0 : 340 } });
    openPopup(st);
  }
  function openPopup(st) {
    if (!S.map) return;
    if (S.popup) S.popup.remove();
    var count = filteredCount(st);
    var node = h('<div><div class="cw-pop-name">' + logoEl(st.r) + "<b>" + esc(st.r) + "</b></div>" +
      '<div class="cw-pop-body">' + esc(storeAddr(st)) +
      '<br><button class="cw-found" aria-expanded="false">' + foundLabel(count) + "</button></div></div>");
    node.querySelector(".cw-found").addEventListener("click", function (e) {
      // On mobile the list panel is hidden behind the Map tab: jump to it so
      // the expansion is actually visible.
      if (isMobile()) setTab("instore");
      var li = S.root.querySelector("#cw_store_" + CSS.escape(String(st.id)));
      if (!li) {
        // shopper panned the map far from their searched area: re-anchor the
        // list to the tapped store so the expansion has somewhere to live
        S.center = { lat: st.lat, lng: st.lng };
        computeResults(); renderList();
        li = S.root.querySelector("#cw_store_" + CSS.escape(String(st.id)));
      }
      if (li && !li.querySelector(".cw-store-products")) toggleStoreProducts(st, li);
      if (li) li.scrollIntoView({ block: "center", behavior: "smooth" });
      e.target.setAttribute("aria-expanded", String(!!(li && li.querySelector(".cw-store-products"))));
    });
    S.popup = new maplibregl.Popup({ offset: [0, -46], className: "flyout", maxWidth: "260px" })
      .setLngLat([st.lng, st.lat]).setDOMContent(node).addTo(S.map);
  }

  /* ---------------- filters panel ---------------- */
  function renderFilters() {
    var grid = S.root.querySelector(".cw-prodgrid");
    grid.innerHTML = "";
    var carried = new Set();
    S.data.stores.forEach(function (st) {
      (st.p || []).forEach(function (pi) { carried.add(pi); });
    });
    S.data.products.forEach(function (p, pi) {
      if (!carried.has(pi)) return;
      var card = h('<button class="cw-prodcard' + (S.activeFilters.has(pi) ? " on" : "") + '" role="checkbox" aria-checked="' + S.activeFilters.has(pi) + '">' +
        '<img alt="" loading="lazy" src="' + esc(p.img) + '"><span class="n">' + esc(p.name) + '</span><span class="s">' + esc(p.size) + "</span></button>");
      card.addEventListener("click", function () {
        if (S.activeFilters.has(pi)) S.activeFilters.delete(pi); else S.activeFilters.add(pi);
        card.classList.toggle("on"); card.setAttribute("aria-checked", S.activeFilters.has(pi));
        computeResults(); refreshClusterData(); renderList(); updateFilterBtn();
        track("filter_change", { filters: activeFilterNames(), result_count: S.matchCount });
      });
      grid.appendChild(card);
    });
  }
  function updateFilterBtn() {
    var b = S.root.querySelector(".cw-filter-btn");
    b.textContent = S.activeFilters.size ? "Filters (" + S.activeFilters.size + ")" : "Filters";
    var done = S.root.querySelector(".cw-filters-done");
    if (done) {
      var n = S.matchCount || 0;
      done.textContent = "Show " + n.toLocaleString() + " store" + (n === 1 ? "" : "s");
    }
  }

  /* ---------------- Buy Online tab ---------------- */
  function renderOnline() {
    var wrap = S.root.querySelector(".cw-online");
    if (wrap.dataset.done) return;
    wrap.dataset.done = "1";
    S.data.online.forEach(function (o) {
      if (!o.retailers.length) return; // no online retailers: don't render a dead section
      var sec = h('<section class="cw-online-section"><h2 class="cw-online-title">' + esc(o.product) + " | " + esc(o.size) + "</h2></section>");
      var row = h('<div class="cw-online-row"><a class="cw-online-img" href="' + esc(o.pdp) + '" target="_blank" rel="noopener"><img alt="' + esc(o.product) + '" loading="lazy" src="' + esc(o.img) + '"></a><div class="cw-online-list"></div></div>');
      row.querySelector(".cw-online-img").addEventListener("click", function () {
        track("pdp_click", { product: o.product + " " + o.size, url: o.pdp });
      });
      var list = row.querySelector(".cw-online-list");
      var vis = o.retailers.slice(0, 2), hid = o.retailers.slice(2);
      vis.forEach(function (r) { list.appendChild(retailerRow(r, o)); });
      if (hid.length) {
        var more = h('<button class="cw-more" aria-expanded="false">' + hid.length + " more retailer" + (hid.length === 1 ? "" : "s") + " ▾</button>");
        more.addEventListener("click", function () {
          hid.forEach(function (r) { list.appendChild(retailerRow(r, o)); });
          more.remove();
        });
        sec.appendChild(row); sec.appendChild(more);
      } else { sec.appendChild(row); }
      wrap.appendChild(sec);
    });
  }
  function retailerRow(r, o) {
    var row = h('<div class="cw-retailer-row">' + logoEl(r.name) +
      '<span class="rn">' + esc(r.name) + "</span>" +
      '<a class="cw-shop-btn" role="link" href="' + esc(r.url) + '" target="_blank" rel="noopener">Shop Now<span class="sr-only"> ' + esc(o.product) + " at " + esc(r.name) + "</span></a></div>");
    row.querySelector(".cw-shop-btn").addEventListener("click", function () {
      track("shop_now", { retailer: r.name, product: o.product + " " + o.size, url: r.url });
    });
    return row;
  }

  /* ---------------- tabs ---------------- */
  function setTab(tab, silent) {
    if (!S.data) return;
    var fromTab = S.tab;
    S.tab = tab;
    S.root.classList.toggle("map-open", tab === "map");
    S.root.classList.toggle("list-open", tab !== "map");
    S.root.classList.toggle("online-open", tab === "online");
    if (tab !== "map" && S.popup) { S.popup.remove(); S.popup = null; }
    var showOnline = tab === "online";
    S.root.querySelector(".cw-list").style.display = showOnline || tab === "map" ? "none" : "";
    S.root.querySelector(".cw-online").style.display = showOnline ? "" : "none";
    S.root.querySelector(".cw-pager").style.display = showOnline || tab === "map" ? "none" : (S.results.length > PAGE_SIZE ? "" : "none");
    S.root.querySelectorAll(".cw-tab").forEach(function (b) {
      var on = b.dataset.tab === tab;
      b.classList.toggle("active", on); b.setAttribute("aria-selected", on);
    });
    if (showOnline) renderOnline();
    if (tab === "map") {
      if (S.initMap) S.initMap();
      if (S.map) { S.map.resize(); fitToResults(S.lastPage); }
    }
    if (!silent) track("tab_switch", { via: fromTab + ">" + tab });
  }

  /* ---------------- search UI ---------------- */
  function bindSearch() {
    var input = S.root.querySelector(".cw-search input");
    var ac = S.root.querySelector(".cw-ac");
    function choose(item) {
      clearTimeout(S.acTimer);
      input.value = item.label;
      hideAc();
      showSearchError("");
      S.userChoseLocation = true;
      S.center = item.pt;
      computeResults(); renderList();
      rememberLocation(item.pt.lat, item.pt.lng, item.label, "search");
      track("search", { query: item.label, resolved_label: item.label, lat: item.pt.lat, lng: item.pt.lng, result_count: S.matchCount, nearest_mi: nearestMi() });
    }
    function hideAc() { ac.hidden = true; ac.innerHTML = ""; S.acItems = []; S.acIndex = -1; }
    function submit() {
      var q = input.value.trim();
      if (!q) return;
      clearTimeout(S.acTimer);
      hideAc();
      geocode(q).then(function (res) {
        input.value = res.label || q;
        showSearchError("");
        S.userChoseLocation = true;
        S.center = res.pt;
        computeResults(); renderList();
        rememberLocation(res.pt.lat, res.pt.lng, res.label || q, "search");
        track("search", { query: q, resolved_label: res.label || q, lat: res.pt.lat, lng: res.pt.lng, result_count: S.matchCount, nearest_mi: nearestMi() });
      }).catch(function () {
        track("search", { query: q, result_count: 0 });
        var msg = "We couldn't find that location. Try a city name or 5-digit zip.";
        showSearchError(msg);
        var wrap = S.root.querySelector(".cw-list");
        wrap.innerHTML = '<div class="cw-empty">' + msg + "</div>";
      });
    }
    function showAcItems(items) {
      S.acItems = items; S.acIndex = -1;
      if (!items.length) { hideAc(); return; }
      ac.innerHTML = "";
      items.forEach(function (it) {
        var li = h('<li role="option">' + esc(it.label) + "</li>");
        li.addEventListener("mousedown", function (e) { e.preventDefault(); choose(it); });
        ac.appendChild(li);
      });
      ac.hidden = false;
    }
    input.addEventListener("input", function () {
      var q = input.value.trim();
      clearTimeout(S.acTimer);
      // partial zip: suggest completions instantly (full US index lazy-loads on
      // first digit; store-zip table covers the gap while it downloads)
      if (/^\d{1,5}$/.test(q)) {
        loadFullZips(function () {
          var qq = input.value.trim();
          if (/^\d{2,5}$/.test(qq) && document.activeElement === input) showAcItems(zipSuggestions(qq));
        });
        if (q.length >= 2) showAcItems(zipSuggestions(q)); else hideAc();
        return;
      }
      if (q.length < 3 || /^\d+$/.test(q)) { hideAc(); return; }
      S.acTimer = setTimeout(function () {
        autocomplete(q, function (items) {
          if (document.activeElement !== input) return; // stale response after submit/blur
          showAcItems(items);
        });
      }, 250);
    });
    // Tapping into a prefilled field clears it for fresh typing (restored if the
    // shopper leaves without typing) — avoids the iOS caret floating at the end
    // of long text next to the GPS icon.
    input.addEventListener("focus", function () {
      if (input.value) { input.dataset.prev = input.value; input.value = ""; }
    });
    input.addEventListener("blur", function () {
      setTimeout(function () {
        if (!input.value && input.dataset.prev) { input.value = input.dataset.prev; delete input.dataset.prev; }
      }, 200);
    });
    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter") {
        if (S.acIndex >= 0 && S.acItems[S.acIndex]) choose(S.acItems[S.acIndex]); else submit();
      } else if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        if (ac.hidden) return;
        e.preventDefault();
        S.acIndex = (S.acIndex + (e.key === "ArrowDown" ? 1 : -1) + S.acItems.length) % S.acItems.length;
        [].forEach.call(ac.children, function (n, i) { n.setAttribute("aria-selected", i === S.acIndex); });
      } else if (e.key === "Escape") { hideAc(); }
    });
    input.addEventListener("blur", function () { setTimeout(hideAc, 150); });
    S.root.querySelector(".cw-search-btn").addEventListener("click", submit);
  }

  /* ---------------- initial location ---------------- */
  // Precise location. IP lookup resolves to the carrier's hub (often 50-150 mi
  // off), so we upgrade to browser geolocation: silently when already granted,
  // otherwise one prompt per visitor, remembered so a denial never nags again.
  function applyPreciseLocation(lat, lng, userInitiated) {
    // Auto-GPS may only upgrade IP / default. An explicit search, a restored
    // search, or an in-progress typed query must win. The GPS button always
    // applies (userInitiated).
    if (!userInitiated) {
      if (S.userChoseLocation) return;
      var focused = S.root && S.root.querySelector(".cw-search input");
      if (focused && document.activeElement === focused) return;
    }
    S.center = { lat: lat, lng: lng };
    var input = S.root.querySelector(".cw-search input");
    var near = null, best = Infinity;
    (S.data ? S.data.stores : []).forEach(function (st) {
      var d = haversine(S.center, st);
      if (d < best) { best = d; near = st; }
    });
    var label = near ? near.c + ", " + near.s : "Your location";
    if (input) input.value = label;
    showSearchError("");
    computeResults(); renderList();
    rememberLocation(lat, lng, label, "gps");
    track("locate", { via: "gps", lat: Math.round(lat * 100) / 100, lng: Math.round(lng * 100) / 100,
      result_count: S.matchCount, nearest_mi: nearestMi() });
  }
  function requestPreciseLocation(userInitiated) {
    if (!navigator.geolocation) return;
    var pref = null;
    try { pref = localStorage.getItem("cw_geo"); } catch (e) { /* storage blocked */ }
    if (!userInitiated && pref === "denied") return;   // respect a previous no
    function ask() {
      navigator.geolocation.getCurrentPosition(function (pos) {
        try { localStorage.setItem("cw_geo", "granted"); } catch (e) {}
        applyPreciseLocation(pos.coords.latitude, pos.coords.longitude, userInitiated);
      }, function (err) {
        if (err && err.code === 1) { try { localStorage.setItem("cw_geo", "denied"); } catch (e) {} }
      }, { timeout: 8000, maximumAge: 300000 });
    }
    if (userInitiated) return ask();
    if (navigator.permissions && navigator.permissions.query) {
      navigator.permissions.query({ name: "geolocation" }).then(function (p) {
        if (p.state === "granted") return ask();
        if (p.state === "prompt" && pref !== "asked") {
          try { localStorage.setItem("cw_geo", "asked"); } catch (e) {}
          ask();
        }
      }).catch(ask);
    } else if (pref !== "asked") {
      try { localStorage.setItem("cw_geo", "asked"); } catch (e) {}
      ask();
    }
  }
  // IP providers, best-accuracy first. Measured against a known address, ipapi.co
  // resolved within ~15 miles where ipwho.is was ~154 off (it returns the
  // carrier's hub). ipwho.is stays as an unmetered fallback since ipapi.co's free
  // tier is capped per day.
  var IP_PROVIDERS = [
    { name: "ipapi.co", url: "https://ipapi.co/json/", parse: function (d) {
        return d && !d.error && d.country_code === "US" && d.latitude
          ? { lat: d.latitude, lng: d.longitude,
              label: [d.city, d.region_code, d.postal].filter(Boolean).join(", ") } : null; } },
    { name: "ipwho.is", url: "https://ipwho.is/", parse: function (d) {
        return d && d.success && d.country_code === "US"
          ? { lat: d.latitude, lng: d.longitude,
              label: [d.city, d.region_code, d.postal].filter(Boolean).join(", ") } : null; } }
  ];

  // A location the shopper chose (searched or GPS) is remembered so a return
  // visit opens on their own area instead of re-guessing from IP.
  function rememberLocation(lat, lng, label, via) {
    try {
      localStorage.setItem("cw_loc", JSON.stringify({
        lat: lat, lng: lng, label: label, t: Date.now(), via: via || "search"
      }));
    } catch (e) { /* storage blocked */ }
  }
  function savedLocation() {
    try {
      var v = JSON.parse(localStorage.getItem("cw_loc") || "null");
      if (v && v.lat && Date.now() - v.t < 90 * 86400000) return v;  // 90 days
    } catch (e) { /* storage blocked or corrupt */ }
    return null;
  }

  function ipLocate(i) {
    i = i || 0;
    if (i >= IP_PROVIDERS.length) return;
    var p = IP_PROVIDERS[i];
    fetch(p.url).then(function (r) { return r.json(); }).then(function (d) {
      if (S.center && !S.center.isDefault) return;  // user already searched or used GPS
      var hit = p.parse(d);
      if (!hit) return ipLocate(i + 1);
      S.center = { lat: hit.lat, lng: hit.lng };
      var input = S.root.querySelector(".cw-search input");
      if (input) input.value = hit.label;
      computeResults(); renderList();
      track("locate", { via: "ip", resolved_label: hit.label,
        lat: Math.round(hit.lat * 100) / 100, lng: Math.round(hit.lng * 100) / 100,
        result_count: S.matchCount, nearest_mi: nearestMi(), query: p.name });
    }).catch(function () { ipLocate(i + 1); });
  }

  function detectLocation() {
    // Precise browser geolocation runs alongside, and wins when available.
    setTimeout(function () { requestPreciseLocation(false); }, 400);

    // A remembered choice beats any fresh guess.
    var saved = savedLocation();
    if (saved) {
      S.center = { lat: saved.lat, lng: saved.lng };
      // Legacy cw_loc rows have no via. Treat those as a search so auto-GPS
      // cannot clobber a city the shopper picked on a prior visit.
      if (saved.via !== "gps") S.userChoseLocation = true;
      var input = S.root.querySelector(".cw-search input");
      if (input) input.value = saved.label || "";
      computeResults(); renderList();
      track("locate", { via: "saved", resolved_label: saved.label,
        result_count: S.matchCount, nearest_mi: nearestMi() });
      return;
    }
    ipLocate(0);
  }

  /* ---------------- boot ---------------- */
  function buildShell(root) {
    root.classList.add("cw", "list-open");
    var GPS_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 0c17.7 0 32 14.3 32 32V66.7C368.4 80.1 431.9 143.6 445.3 224H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H445.3C431.9 368.4 368.4 431.9 288 445.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C143.6 431.9 80.1 368.4 66.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V32c0-17.7 14.3-32 32-32zM128 256a128 128 0 1 0 256 0 128 128 0 1 0 -256 0zm128-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"/></svg>';
    // Note: .cw-map is intentionally LAST in the DOM (absolute positioning makes
    // order invisible) so MapLibre's canvas/attribution tab-stops come after all
    // widget controls and results.
    root.innerHTML =
      '<a class="cw-skip" href="#cw-results">Skip to results</a>' +
      '<div class="cw-controls">' +
        '<button class="cw-filter-btn" aria-expanded="false" aria-label="Product Filter">Filters</button>' +
        '<div class="cw-search"><span class="cw-search-tip">City or Zip</span>' +
          '<input aria-label="Search city or zip, type 3 or more characters for results" autocomplete="postal-code" placeholder="">' +
          '<button class="cw-gps-btn" aria-label="Use my location" title="Use my location">' + GPS_SVG + "</button>" +
          '<button class="cw-search-btn" aria-label="Search">' + SEARCH_SVG + "</button>" +
          '<ul class="cw-ac" role="listbox" hidden></ul>' +
          '<div class="cw-search-error" role="alert" hidden></div>' +
        "</div>" +
      "</div>" +
      '<div class="cw-filters" hidden>' +
        '<div class="cw-filters-head"><h3>Filter by product</h3><button class="cw-filters-reset">Reset</button></div>' +
        '<div class="cw-prodgrid" role="group" aria-label="Product filters"></div>' +
        '<div class="cw-filters-foot"><button class="cw-filters-done">Show stores</button></div>' +
      "</div>" +
      '<div class="cw-panel">' +
        '<div class="cw-tabs" role="tablist">' +
          '<button class="cw-tab cw-tab-map" role="tab" data-tab="map" aria-selected="false">Map</button>' +
          '<button class="cw-tab active" role="tab" data-tab="instore" aria-selected="true">Store List</button>' +
          '<button class="cw-tab" role="tab" data-tab="online" aria-selected="false">Buy Online</button>' +
        "</div>" +
        '<div class="cw-list" id="cw-results" aria-live="polite"></div>' +
        '<div class="cw-online" style="display:none"></div>' +
        '<div class="cw-pager" style="display:none">' +
          '<button class="cw-pager-btn prev">Previous</button>' +
          '<span class="cw-pager-info"></span>' +
          '<button class="cw-pager-btn next">Next</button>' +
        "</div>" +
      "</div>" +
      '<div class="cw-mapctl">' +
        '<div class="cw-pan"><button class="up" aria-label="Pan map up" tabindex="-1">▲</button><button class="dn" aria-label="Pan map down" tabindex="-1">▼</button><button class="lf" aria-label="Pan map left" tabindex="-1">◀</button><button class="rt" aria-label="Pan map right" tabindex="-1">▶</button></div>' +
        '<div class="cw-zoom"><button class="zin" aria-label="Zoom in">+</button><button class="zout" aria-label="Zoom out">−</button></div>' +
      "</div>" +
      '<div class="cw-map" role="application" aria-label="Store map"></div>';
  }

  function init(opts) {
    S.opts = Object.assign({ el: "#counter-locator", dataUrl: "data/stores.json", logoBase: "logos/", zipsUrl: null }, opts || {});
    S.root = typeof S.opts.el === "string" ? document.querySelector(S.opts.el) : S.opts.el;
    if (!S.root) return;
    buildShell(S.root);

    // The host theme nukes button backgrounds on :focus (background:transparent
    // !important) unless the button carries its .alt-focus opt-out class.
    // Apply it to every widget button, including ones rendered later.
    function altFocus(root) {
      root.querySelectorAll("button:not(.alt-focus)").forEach(function (b) { b.classList.add("alt-focus"); });
    }
    altFocus(S.root);
    new MutationObserver(function () { altFocus(S.root); })
      .observe(S.root, { childList: true, subtree: true });

    // Map init is deferred until the widget approaches the viewport: MapLibre +
    // style + sprites are ~545KB the shopper shouldn't pay above the fold.
    var mapStarted = false;
    S.initMap = function () {
      if (mapStarted) return;
      mapStarted = true;
      startMap();
    };
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { S.initMap(); io.disconnect(); }
      }, { rootMargin: "600px" });
      io.observe(S.root);
      setTimeout(S.initMap, 6000); // fallback: never leave the map uninitialized long
    } else {
      S.initMap();
    }

    bindControls();
    loadData(0);
  }

  function startMap() {
    // Map is an enhancement: if MapLibre failed to load (CDN outage), the
    // list, search, filters, and Buy Online must all keep working.
    if (window.maplibregl) {
      S.map = new maplibregl.Map({
        container: S.root.querySelector(".cw-map"),
        style: MAP_STYLE,
        center: [-96.5, 39.2], zoom: 4,
        attributionControl: { compact: true }
      });
      // Counter map aesthetics: warm beige land, crisp state/country lines,
      // stronger state labels (the stock style's boundaries are muted dashes).
      S.map.on("style.load", function () {
        try {
          S.map.setPaintProperty("background", "background-color", "#f6efe2");
          ["landuse-residential", "landcover-sand"].forEach(function (id) {
            if (S.map.getLayer(id)) S.map.setPaintProperty(id, "fill-color", "#f2e9d8");
          });
          var A = Object.assign({
            stateColor: "hsl(28,10%,44%)", stateDash: null,
            stateWidth: ["interpolate", ["linear"], ["zoom"], 3, 0.9, 6, 1.5, 11, 2.6],
            countryColor: "hsl(248,6%,48%)",
            stateLabelColor: "#5a5044", stateLabelSize: 13
          }, S.opts.mapAesthetics || {});
          if (S.map.getLayer("boundary_3")) {
            S.map.setPaintProperty("boundary_3", "line-color", A.stateColor);
            S.map.setPaintProperty("boundary_3", "line-width", A.stateWidth);
            if (A.stateDash) S.map.setPaintProperty("boundary_3", "line-dasharray", A.stateDash);
            else S.map.setPaintProperty("boundary_3", "line-dasharray", [1, 0]);
            S.map.setLayerZoomRange("boundary_3", 2, 24);
          }
          if (S.map.getLayer("boundary_2")) {
            S.map.setPaintProperty("boundary_2", "line-color", A.countryColor);
          }
          if (S.map.getLayer("label_state")) {
            S.map.setPaintProperty("label_state", "text-color", A.stateLabelColor);
            if (A.stateLabelSize) S.map.setLayoutProperty("label_state", "text-size", A.stateLabelSize);
          }
        } catch (e) { /* style ids may change upstream; tint is cosmetic */ }
      });
      S.map.on("click", function () { if (S.popup) { S.popup.remove(); S.popup = null; } });
      S.map.on("error", function () { /* tile/style errors are non-fatal */ });
      S.map.on("moveend", syncViewportMarkers);
      S.map.on("load", ensureClusterSource);
      if (S.opts.cluster) Object.assign(CLUSTER, S.opts.cluster);
      if (S.data) ensureClusterSource();
      // Collapse the compact attribution (MapLibre leaves it expanded, which puts
      // its links early in the tab order).
      S.map.on("load", function () {
        var att = S.root.querySelector("details.maplibregl-ctrl-attrib");
        if (att) { att.removeAttribute("open"); att.classList.remove("maplibregl-compact-show"); }
      });
      if (S.lastPage) renderMarkers(S.lastPage);
    } else {
      S.root.querySelector(".cw-mapctl").style.display = "none";
      S.root.querySelector(".cw-tab-map").style.display = "none";
    }
  }

  function bindControls() {
    // custom controls
    S.root.querySelector(".zin").addEventListener("click", function () { if (S.map) S.map.zoomIn(); });
    S.root.querySelector(".zout").addEventListener("click", function () { if (S.map) S.map.zoomOut(); });
    var PAN = 140;
    [["up", 0, -PAN], ["dn", 0, PAN], ["lf", -PAN, 0], ["rt", PAN, 0]].forEach(function (p) {
      S.root.querySelector(".cw-pan ." + p[0]).addEventListener("click", function () {
        if (S.map) S.map.panBy([p[1], p[2]]);
      });
    });

    S.root.querySelector(".cw-gps-btn").addEventListener("click", function () {
      requestPreciseLocation(true);
    });

    S.root.querySelectorAll(".cw-tab").forEach(function (b) {
      b.addEventListener("click", function () { setTab(b.dataset.tab); });
    });

    S.root.querySelector(".cw-pager .prev").addEventListener("click", function () {
      if (S.page > 0) { S.page--; renderList(); track("paginate", { page: S.page + 1 }); }
    });
    S.root.querySelector(".cw-pager .next").addEventListener("click", function () {
      var total = Math.ceil(S.results.length / PAGE_SIZE);
      if (S.page < total - 1) { S.page++; renderList(); track("paginate", { page: S.page + 1 }); }
    });

    var fbtn = S.root.querySelector(".cw-filter-btn");
    var fpanel = S.root.querySelector(".cw-filters");
    fbtn.addEventListener("click", function () {
      var open = fpanel.hidden;
      fpanel.hidden = !open;
      fbtn.setAttribute("aria-expanded", open);
      fbtn.classList.toggle("active", open);
    });
    S.root.querySelector(".cw-filters-reset").addEventListener("click", function () {
      S.activeFilters.clear(); renderFilters();
      computeResults(); refreshClusterData(); renderList(); updateFilterBtn();
      track("filter_change", { filters: "reset", result_count: S.matchCount });
    });
    S.root.querySelector(".cw-filters-done").addEventListener("click", function () {
      fpanel.hidden = true; fbtn.setAttribute("aria-expanded", "false"); fbtn.classList.remove("active");
      fbtn.focus();
    });
    document.addEventListener("click", function (e) {
      if (!fpanel.hidden && !e.target.closest(".cw-filters") && !e.target.closest(".cw-filter-btn")) {
        fpanel.hidden = true; fbtn.setAttribute("aria-expanded", "false"); fbtn.classList.remove("active");
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !fpanel.hidden) {
        fpanel.hidden = true; fbtn.setAttribute("aria-expanded", "false"); fbtn.classList.remove("active"); fbtn.focus();
      }
    });
  }

  function loadData(attempt) {
    fetch(S.opts.dataUrl).then(function (r) {
      if (!r.ok) throw new Error("HTTP " + r.status);
      return r.json();
    }).then(function (data) {
      S.data = data;
      S.center = DEFAULT_CENTER;
      buildZipTable();
      renderFilters();
      bindSearch();
      ensureClusterSource();
      computeResults(); renderList();
      // Mobile leads with the map (Jeff, 2026-07-29): pins near you beat a list.
      if (isMobile()) setTab("map", true);
      track("widget_load", { result_count: S.data.stores.length });
      detectLocation();
    }).catch(function () {
      if (attempt < 2) return setTimeout(function () { loadData(attempt + 1); }, 1500 * (attempt + 1));
      var wrap = S.root.querySelector(".cw-list");
      wrap.innerHTML = '<div class="cw-empty">We had trouble loading store data. ' +
        '<button class="cw-pager-btn" style="display:block;margin-top:10px">Try again</button></div>';
      wrap.querySelector("button").addEventListener("click", function () { loadData(0); });
    });
  }

  window.CounterLocator = { init: init, _state: S };
})();
